import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";

export default function ProgramTable({
  handleSubmit,
  programModal,
  data,
  deleteRow
}) {
  const columns = [
    {
      dataField: "fund_type.name",
      text: "Jenis Dana"
    },
    {
      dataField: "name",
      text: "Program"
    },
    {
      dataField: "",
      text: "Actions",
      formatExtraData: {
        blockOrg: BlockOrg()
      },
      formatter: (cell, row, index, { blockOrg }) => {
        return (
          <>
            {blockOrg && (
              <OverlayTrigger
                overlay={
                  <Tooltip id="products-delete-tooltip">Hapus Program</Tooltip>
                }
              >
                <a
                  className="btn btn-icon btn-light btn-hover-danger btn-sm"
                  onClick={() => deleteRow(row)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
          </>
        );
      }
    }
  ];

  return (
    <>
      <Card>
        <CardHeader title="Program">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <button className="btn btn-primary" onClick={programModal}>
                Tambah Program
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={data}
            columns={columns}
          />
        </CardBody>
        <CardFooter>
          {BlockOrg() && (
            <button
              className="btn btn-primary float-right"
              onClick={handleSubmit}
            >
              Simpan
            </button>
          )}
        </CardFooter>
      </Card>
    </>
  );
}
